import App from '@/App.vue'
import { i18nConfig } from '@/plugins/i18n'
import initSentry from '@/plugins/sentry'
import '@/plugins/vee-validate'
import router from '@/router'
import store from '@/store'
import { createApp } from 'vue'

import '@/plugins/bootstrap-vue'
import 'bootstrap-icons/font/bootstrap-icons.css'

import '@/assets/scss/app.scss'

import pinia from '@/plugins/pinia'
import '@/plugins/smoothscroll'
import gtm from '@/plugins/vue-gtm'
import '@/plugins/vue-meta'
import '@/plugins/vue-social-sharing'
import '@/plugins/vue-the-mask'

// @ts-ignore
import { plugin as wiosnaUI } from '@wiosna-dev/wiosna-ui'
import 'bootstrap/dist/js/bootstrap.bundle'
import forEach from 'lodash.foreach'
import type { Component, FunctionalComponent } from 'vue'

const app = createApp(App)

initSentry(app, router)

app
  .use(store)
  .use(pinia)
  .use(router)
  .use(gtm)
  // @ts-ignore
  .use(wiosnaUI, {
    i18n: i18nConfig
  })
  .mount('#app')
// iterate registered components to set WIOSNA-UI component's compatConfig to MODE 3

forEach(app._context.components, (c: Component) => {
  const component = c as FunctionalComponent
  if (component.__name?.charAt(0) === 'W') {
    component.compatConfig = { MODE: 3 }
  }
})
